import { render, staticRenderFns } from "./plan-list.vue?vue&type=template&id=9daa3d04&scoped=true"
import script from "./plan-list.vue?vue&type=script&lang=ts"
export * from "./plan-list.vue?vue&type=script&lang=ts"
import style0 from "./plan-list.vue?vue&type=style&index=0&id=9daa3d04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9daa3d04",
  null
  
)

export default component.exports